// src/hooks/useSuiviNcs.ts — SCE Issues
// L'instantané du suivi des NC-S (06/10), lu une fois par session et partagé
// par les fiches ; après une mise à jour par la recherche de fond
// (`publierSuiviNcs`), diffusé aux composants montés.

import { useEffect, useState } from 'react'
import { lireSuiviNcs } from '@/api/suiviNcs.api'
import type { BlocSuiviNcs, SuiviNcs } from '@/utils/suiviNcs'

let promesse: Promise<BlocSuiviNcs | null> | null = null
const abonnes = new Set<(bloc: BlocSuiviNcs | null) => void>()

function charger(): Promise<BlocSuiviNcs | null> {
  // Sans suivi lisible, le badge montre le N° seul : rien ne casse.
  promesse ??= lireSuiviNcs().catch(() => null)
  return promesse
}

export function publierSuiviNcs(bloc: BlocSuiviNcs): void {
  promesse = Promise.resolve(bloc)
  for (const f of abonnes) f(bloc)
}

/** Le suivi de la NC-S `numero` (undefined tant qu'il n'est pas connu). */
export function useSuiviNcs(numero: string | undefined): SuiviNcs | undefined {
  const [bloc, setBloc] = useState<BlocSuiviNcs | null>(null)
  useEffect(() => {
    let actif = true
    void charger().then((b) => {
      if (actif) setBloc(b)
    })
    const abonne = (b: BlocSuiviNcs | null): void => setBloc(b)
    abonnes.add(abonne)
    return () => {
      actif = false
      abonnes.delete(abonne)
    }
  }, [])
  return numero ? bloc?.ncs[numero] : undefined
}
